<template>
  <v-container
    id="shop-table"
    tag="section"
  >
    <base-material-card
      color="indigo"
      icon="mdi-clipboard-check"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ title }} #{{ order.orderNumber }}
        </div>
      </template>
      <v-row class="mt-5">
        <v-col
          cols="6"
          md="4"
        >
          <div>
            <v-select
              v-model="order.status"
              :items="orderStateItems"
              item-text="label"
              item-value="value"
              :label="$t('fields.order.status')"
              :disabled="true"
              outlined
              @change="showControls()"
            />
          </div>
        </v-col>
        <v-col
          cols="6"
          md="4"
          style="padding-left:16px"
        >
          <h4
            class="mt-0"
            style="font-weight:500;"
          >
            Tracking:
          </h4>
          <p class="mb-0">
            {{ order.trackNumber }}
          </p>
          <p>{{ order.courierName }}</p>
        </v-col>
        <v-col
          cols="12"
          md="4"
          style="padding-left:25px"
        >
          <template>
            <div>
              <v-dialog
                v-model="dialogRevoke"
                persistent
                width="500"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    x-large
                    color="warning"
                    dark
                    v-bind="attrs"
                    :loading="loadingSave"
                    v-on="on"
                  >
                    Anular Orden
                  </v-btn>
                </template>
                <v-card v-if="!loadingOrder">
                  <v-card-title
                    class="warning lighten-2"
                    style="text-align: left;font-weight: 500;letter-spacing: 0.0125em;padding: 16px 24px 10px;color:#393939;"
                  >
                    ANULAR ÓRDEN
                  </v-card-title>

                  <v-card-text v-if="order.paymentMethod.code === 'visa'">
                    <div>
                      <div
                        style="display: flex;flex-direction: row;justify-content: space-between;"
                      >
                        <span>Tipo de pago: </span><span>{{ order.paymentDetail }}</span>
                      </div>
                      <div style="display: flex;flex-direction: row;justify-content: space-between;">
                        <span>Tarjeta: </span><span>xxxx-xxxx-xxxx-{{ order.creditCardTerminationNumber }}</span>
                      </div>
                      <div style="display: flex;flex-direction: row;justify-content: space-between;">
                        <span>Transacción ID: </span><span>{{ order.transactionId }}</span>
                      </div>
                      <div style="display: flex;flex-direction: row;justify-content: space-between;">
                        <span>Total: </span><span>${{ order.totalWithShipping }}</span>
                      </div>
                    </div>
                    <p
                      v-if="switchPayment"
                      class="warning"
                      style="text-align:center; margin-top:15px;color:white"
                    >
                      Al anular esta órden se creará la nota de crédito y se hará la devolución del total al cliente.
                    </p>
                    <v-sheet class="pl-5">
                      <v-switch
                        v-model="switchPayment"
                        inset
                        color="warning"
                        label="Anular el pago de esta orden automáticamente en la plataforma del BAC"
                      />
                    </v-sheet>
                    <p style="font-weight:600;font-size:18px;text-align:center;">
                      ¿Desea continuar?
                    </p>
                  </v-card-text>
                  <v-card-text v-else-if="order.paymentMethod.code === 'transfer'">
                    <div>
                      <div
                        style="display: flex;flex-direction: row;justify-content: space-between;"
                      >
                        <span>Tipo de pago: </span><span>{{ order.paymentDetail }}</span>
                      </div>
                      <div style="display: flex;flex-direction: row;justify-content: space-between;">
                        <span>Banco: </span><span>{{ order.transferBankDetail }}</span>
                      </div>
                      <div style="display: flex;flex-direction: row;justify-content: space-between;">
                        <span>Documento: </span><span>{{ order.transferNumber }}</span>
                      </div>
                      <div style="display: flex;flex-direction: row;justify-content: space-between;">
                        <span>Total: </span><span>${{ order.totalWithShipping }}</span>
                      </div>
                    </div>

                    <a
                      v-if="get_url_extension(order.imageUrl) === 'pdf'"
                      class=""
                      :href="order.imageUrl"
                      target="_blank"
                    ><span asp-loc>COMPROBANTE</span></a>
                    <v-btn
                      v-else
                      color="success"
                      class="px-1 ml-1 d-flex d-sm-none"
                      fab
                      x-small
                    >
                      <v-icon

                        @click="showDialog(order.imageUrl)"
                      >
                        mdi-file-image
                      </v-icon>
                    </v-btn>
                    <v-img
                      class="d-none d-sm-flex"
                      :lazy-src="order.imageUrl"
                      max-height="400px"
                      max-width="100%"
                      :src="order.imageUrl"
                      @click="showDialog(order.imageUrl)"
                    />

                    <p
                      class="error"
                      style="text-align:center; margin-top:15px;color:white"
                    >
                      Antes de anular esta órden, la devolución del dinero debe hacerse de forma manual en la plataforma correspondiente.
                    </p>
                    <v-text-field
                      v-model="order.reason"
                      label="Motivo de anulación"
                    />
                    <p style="font-weight:600;font-size:18px;text-align:center;">
                      ¿Desea marcar esta órden como nula y crear la nota de crédito?
                    </p>
                  </v-card-text>
                  <v-card-text v-else-if="order.paymentMethod.code === 'paypal'">
                    <div>
                      <div
                        style="display: flex;flex-direction: row;justify-content: space-between;"
                      >
                        <span>Tipo de pago: </span><span>{{ order.paymentDetail }}</span>
                      </div>
                      <div style="display: flex;flex-direction: row;justify-content: space-between;">
                        <span>Email del cliente: </span><span>{{ order.paypalPayerEmail }}</span>
                      </div>
                      <div style="display: flex;flex-direction: row;justify-content: space-between;">
                        <span>Transacción ID paypal: </span><span>{{ order.paypalTransactionId }}</span>
                      </div>
                      <div style="display: flex;flex-direction: row;justify-content: space-between;">
                        <span>Total: </span><span>${{ order.totalWithShipping }}</span>
                      </div>
                    </div>
                    <p
                      class="error"
                      style="text-align:center; margin-top:15px;color:white"
                    >
                      Antes de anular esta órden, la devolución del dinero debe hacerse de forma manual en la plataforma correspondiente.
                    </p>
                    <p style="font-weight:600;font-size:18px;text-align:center;">
                      ¿Desea marcar esta órden como nula y crear la nota de crédito?
                    </p>
                  </v-card-text>

                  <v-divider />

                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      color="red"
                      text
                      @click="dialogRevoke = false"
                    >
                      Cancelar
                    </v-btn>
                    <v-btn
                      color="primary"
                      text
                      @click="revokeOrder()"
                    >
                      Aceptar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </template>
        </v-col>
      </v-row>
      <order-summary :order="order" />
      <v-divider />
      <v-data-table
        :headers="localizationHeaders"
        :items="order.orderDetail"
        :sort-by="['name']"
        :sort-desc="[false]"
        :loading="loadingOrder"
      >
        <!-- <template v-slot:top>
          <v-toolbar
            flat
            color="white"
          >
            <v-spacer />
            <v-btn
              elevation="1"
              color="primary"
              dark
              fab
              min-width="0"
              small
              @click="addOrder"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-toolbar>
        </template> -->
        <!-- <template v-slot:[`item.status`]="{ item }">
          {{ item.status ? "Activo": "Inactivo" }}
        </template> -->
        <template v-slot:[`item.totalLine`]="{ item }">
          {{ "$" + item.totalLine }}
        </template>
        <template v-slot:[`item.price`]="{ item }">
          {{ "$" + item.price }}
        </template>
        <template v-slot:[`item.discount`]="{ item }">
          {{ "$" + item.discountAmount }}
        </template>
        <template v-slot:[`item.imageUrl`]="{ item }">
          <v-btn
            color="success"
            class="px-1 ml-1 d-flex d-sm-none"
            fab
            x-small
          >
            <v-icon @click="showDialog(item.imageUrl)">
              mdi-file-image
            </v-icon>
          </v-btn>
          <v-img
            class="d-none d-sm-flex"
            :lazy-src="item.imageUrl"
            max-height="100%"
            max-width="50px"
            :src="item.imageUrl"
            @click="showDialog(item.imageUrl)"
          />
        </template>
      </v-data-table>
      <template>
        <div class="text-center">
          <v-dialog
            v-model="dialog"
            width="600"
          >
            <v-card>
              <v-img
                :lazy-src="dialogImage"
                :src="dialogImage"
                @click="dialog = false"
              />
            </v-card>
          </v-dialog>
        </div>
      </template>
    </base-material-card>

    <v-snackbar
      v-model="showErrorMessage"
      top
      :multi-line="true"
      color="error"
    >
      {{ errorMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="showErrorMessage = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar
      v-model="showSuccessMessage"
      top
      :multi-line="true"
      color="success"
    >
      {{ successMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="showSuccessMessage = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
// import axios from 'axios'
  import { repositoryFactory } from '@/api/repositoryFactory'
  import { mapState } from 'vuex'
  const ordersRespository = repositoryFactory.get('orders')
  const credomaticRepository = repositoryFactory.get('credomatic')
  // const gameRaritiesRepository = repositoryFactory.get('gameRarities')
  // const gameLinesRepository = repositoryFactory.get('gameLines')
  // const gameExpansionsRepository = repositoryFactory.get('gameExpansions')
  // const sectionsRepository = repositoryFactory.get('sections')

  export default {
    inject: ['theme'], // ??
    name: 'OrderDeliverEdit',
    $_veeValidate: {
      validator: 'new',
    },
    components: {
      OrderSummary: () => import('../../../components/base/OrderSummary'),
    },
    data: () => ({
      order: {},
      paymentMethods: [],
      showErrorMessage: false,
      showSuccessMessage: false,
      errorMessage: '',
      successMessage: '',
      loadingOrder: true,
      formAction: null,
      loadingSave: false,
      dialog: false,
      dialogRevoke: false,
      dialogImage: '',
      revokeData: {},
      dialogRevokeManual: false,
      switchPayment: true,
    }),
    computed: {
      ...mapState(['orderStateItems']),
      title () {
        // return this.formAction === 'add' ? this.$t('add-order') : this.$t('modify-order')
        return this.$t('order')
      },
      localizationHeaders () {
        return [
          {
            text: this.$t('tables.orderDetail.detail'),
            value: 'detail',
          },
          {
            sortable: false,
            text: this.$t('tables.orderDetail.imageUrl'),
            value: 'imageUrl',
          },
          {
            text: this.$t('tables.orderDetail.quantity'),
            value: 'quantity',
          },
          {
            text: this.$t('tables.orderDetail.price'),
            value: 'price',
          },
          {
            sortable: false,
            text: this.$t('tables.orderDetail.discount'),
            value: 'discount',
          },
          {
            sortable: false,
            text: this.$t('tables.orderDetail.totalLine'),
            value: 'totalLine',
          },
        ]
      },
    },
    async mounted () {
      var self = this
      self.formAction = this.$route.params.id === 'add' ? 'add' : 'modify'

      if (self.formAction !== 'add') {
        self.loadingOrder = true
        var id = this.$route.params.id
        await ordersRespository
          .getById(id)
          .then(response => {
            self.loadingOrder = false
            self.order = Object.assign({}, response.data.data)
            console.log('order', self.order)
          // if (self.order.sections != null) {
          //   self.order.sectionsId = self.order.sections.map((x) => x.id)
          // }
          // if (self.order.orderImage.length > 0) {
          //   self.imagePreview = self.order.orderImage[0].url
          // }
          // if (self.order.gameLineId != null) {
          //   this.getExpansions(self.gameLineId)
          // }
          })
          .catch(err => {
            self.loadingOrder = false
            alert(err)
          })
      }
    },
    methods: {
      async revokeOrder () {
        this.showConfirmDialogs()
        var code = this.order.paymentMethod.code
        switch (code) {
          case 'sinpe':
            console.log('case', code)
            await this.createCreditNote()
            await this.submitForm()
            break
          case 'paypal':
            console.log('case', code)
            await this.createCreditNote()
            await this.submitForm()
            break
          case 'visa':
            console.log('case', code)
            if (this.switchPayment) {
              await this.getOrderToRevoke()
            }
            await this.createCreditNote()
            await this.submitForm()
            break
          case 'transfer':
            console.log('case', code)
            await this.createCreditNote()
            await this.submitForm()
            break
          default:
          // code block
        }
      },
      showControls () {
        if (this.order.status === 'cancel') {
          document.getElementById('reason').style.display = ''
        } else {
          document.getElementById('reason').style.display = 'none'
        }
        document.getElementById('controls').style.display = ''
      },
      showDialog (url) {
        this.dialog = true
        this.dialogImage = url
      },
      submitForm (scope) {
        var self = this
        this.order.status = 'revoke'
        var data = { data: this.order }
        self.loadingSave = true
        if (self.formAction !== 'add') {
          ordersRespository
            .updateOrder(data, this.order.id)
            .then(response => {
              if (response.data.isValid) {
                self.goToList()
              } else {
                self.showErrorMessage = true
                self.errorMessage = response.data.errorMessages[0]
              }
              self.loadingSave = false
            })
            .catch(err => {
              self.errorMessage = err
              self.showErrorMessage = true
              self.loadingSave = false
            })
        } else {
          console.log(data)
          ordersRespository
            .addOrder(data)
            .then(response => {
              if (response.data.isValid) {
                self.goToList()
                self.formAction = 'modify'
              } else {
                self.showErrorMessage = true
                self.errorMessage = response.data.errorMessages[0]
              }
              self.loadingSave = false
            })
            .catch(err => {
              self.errorMessage = err
              self.showErrorMessage = true
              self.loadingSave = false
            })
        }
      },
      selectImage (val) {
        var self = this
        const value = val.target.files[0]
        if (!value) return (self.imagePreview = null)
        self.imagePreview = URL.createObjectURL(value)
        self.imageBytes = value
      },
      changeGame (gameId) {
        this.getExpansions(gameId)
        this.order.gameExpansionId = null
      },
      goToList () {
        this.$router.push({ name: 'orderDelivers' })
      },
      async getOrderToRevoke () {
        var self = this
        self.loadingSave = true
        await credomaticRepository.getOrderToRevoke(self.order.id).then(response => {
          self.revokeData = response.data
          console.log('revokeData', self.revokeData)
          if (this.revokeData.responseCode === '1') {
            this.successMessage = this.revokeData.responseText + '. ' + this.revokeData.responseMessage
            this.showSuccessMessage = true
          } else {
            this.errorMessage = this.revokeData.responseText + '. ' + this.revokeData.responseMessage
            this.showErrorMessage = true
          }
          self.loadingSave = false
        }).catch(err => {
          self.showErrorMessage = true
          self.errorMessage = err
          self.loadingSave = false
        })
      },
      async createCreditNote () {
        var self = this
        self.loadingSave = true
        await ordersRespository.createCreditNote(self.order.id).then(response => {
          console.log('createCreditNote', response)
          if (response.status === 200 && response.data.isValid) {
            this.successMessage = 'Se ha creado la nota de crédito con éxito'
            this.showSuccessMessage = true
          }
        }).catch(err => {
          self.showErrorMessage = true
          self.errorMessage = err
          self.loadingSave = false
        })
      },
      showConfirmDialogs () {
        // ocultar confirm
        this.dialogRevoke = !this.dialogRevoke
      },
      reversePaymentVisa () {
        // TODO
      },
      reversePaymentTransfer () {
        // TODO
      },
      reversePaymentSinpe () {
        // TODO
      },
      get_url_extension (url) {
        return url ? url.split(/[#?]/)[0].split('.').pop().trim() : ''
      },

    },
  }
</script>
<style lang="scss" scoped>
img {
  width: 100%;
  height: 100%;
}
</style>
